// https://dev.to/dmtrkovalenko/the-neatest-way-to-handle-alert-dialogs-in-react-1aoe
import * as React from 'react';
import { createContext, useContext, useRef, useState } from 'react';
import { default as Alert, type AlertOptions } from './Alert';

const AlertContext = createContext<((options: AlertOptions) => Promise<boolean>) | null>(null);

export const useAlert = () => {
    const context = useContext(AlertContext);
    if (!context) {
        throw new Error("useAlert must be used within an AlertProvider");
    }
    return context;
}

const AlertProvider = (props: { children: React.ReactNode }) => {
    const [alertState, setAlertState] = useState<AlertOptions | null>(null);
    const resolver = useRef<(value: boolean) => void | undefined>(undefined);

    const openAlert = (options: AlertOptions) => {
        setAlertState(options);
        return new Promise<boolean>((resolve) => {
            resolver.current = resolve;
        });
    };

    const handleCloseClick = () => {
        resolver.current?.(false);
        setAlertState(null);
    };

    const handleAgreeClick = () => {
        resolver.current?.(true);
        setAlertState(null);
    };

    return (
        <>
            <AlertContext.Provider
                value={openAlert}
                children={props.children}
            />

            <Alert
                open={Boolean(alertState)}
                onAgreeClick={handleAgreeClick}
                onCloseCLick={handleCloseClick}
                title={alertState?.title ?? ""}
                message={alertState?.message ?? ""}
                destructive={alertState?.destructive ?? false}
                agreeButtonTitle={alertState?.agreeButtonTitle ?? ""}
                closeButtonTitle={alertState?.closeButtonTitle ?? ""}
            />
        </>
    );
};

export default AlertProvider;